module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "tips-auto-mask"
  }, [_c('div', {
    staticClass: "tips-auto-wrapper",
    class: {
      'tips-auto-show': _vm.opacityShow, 'tips-auto-hide': !_vm.opacityShow
    }
  }, [_c('div', {
    staticClass: "tips-auto-icon",
    class: _vm.iconClass
  }), _vm._v(" "), _c('div', {
    staticClass: "tips-auto-font"
  }, [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-58ab4fb5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/toast/Toast.vue
// module id = 573
// module chunks = 1